import { Link } from "react-router-dom";

export default function LegalLayout({ title, subtitle, effectiveDate, children, testId, showTemplateDisclaimer = true }) {
  return (
    <div data-testid={testId}>
      <section className="py-16 md:py-20 hero-grid-bg border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center gap-2 text-xs text-slate-500 mb-4">
            <Link to="/" className="hover:text-[#1F1E4E]">Home</Link>
            <span>/</span>
            <span className="text-[#1F1E4E] font-semibold">{title}</span>
          </div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-3">Legal</div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E] leading-[1.05]">{title}</h1>
          {subtitle && <p className="mt-4 text-lg text-slate-600">{subtitle}</p>}
          <div className="mt-4 text-sm text-slate-500">Effective date: <span className="font-semibold text-[#1F1E4E]">{effectiveDate}</span></div>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-2xl border border-slate-200 p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
            {children}
            {showTemplateDisclaimer && (
              <div className="pt-6 border-t border-slate-200 text-xs text-slate-500">
                This document is a template provided for informational purposes. For a legally binding version tailored to your jurisdiction, please review it with qualified legal counsel before publishing.
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <div>
      <h2 className="text-xl md:text-2xl font-extrabold text-[#1F1E4E] tracking-tight mb-3">{heading}</h2>
      <div className="space-y-3 text-slate-700 text-[15px] leading-relaxed">{children}</div>
    </div>
  );
}
